import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useToast } from '../../../../context/ToastContext';

import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';

import api from '../../../../api';
import BtnVoltar from '../../../../components/bntVoltar';

export default function PreviewImportacao() {
    const location = useLocation();
    const navigate = useNavigate();
    const { showToast } = useToast();

    const [produtosProcessados, setProdutosProcessados] = useState([]);
    const [usuario_id, setUsuarioId] = useState(null);
    const [carregando, setCarregando] = useState(false);
    const [imagensPorVariacao, setImagensPorVariacao] = useState({});
    const fileInputsRef = useRef({});
    const [produtosEditaveis, setProdutosEditaveis] = useState({});
    const [categorias, setCategorias] = useState([]);
    const [fornecedores, setFornecedores] = useState([]);
    const [carregandoDados, setCarregandoDados] = useState(true);
    const [progresso, setProgresso] = useState({ atual: 0, total: 0 });
    const [logImportacao, setLogImportacao] = useState([]);

    // Buscar categorias e fornecedores ao carregar a página
    useEffect(() => {
        const carregarDados = async () => {
            try {
                const [resCateg, resForn] = await Promise.all([
                    api.get('/listarcategorias'),
                    api.get('/listarfornecedores')
                ]);
                
                console.log('[DEBUG] Categorias recebidas:', resCateg.data?.categorias);
                console.log('[DEBUG] Fornecedores recebidos:', resForn.data?.fornecedores);
                
                if (resCateg.data?.categorias) {
                    const categsValidas = resCateg.data.categorias.filter(c => c.id_categoria);
                    setCategorias(categsValidas);
                    console.log('[DEBUG] Categorias com ID:', categsValidas);
                }
                if (resForn.data?.fornecedores) {
                    const fornsValidos = resForn.data.fornecedores.filter(f => f.id);
                    setFornecedores(fornsValidos);
                    console.log('[DEBUG] Fornecedores com ID:', fornsValidos);
                } else if (resForn.data?.fornecedores) {
                    const fornsValidos = resForn.data.fornecedores.filter(f => f.id);
                    setFornecedores(fornsValidos);
                }
            } catch (error) {
                console.error('Erro ao carregar categorias e fornecedores:', error);
                showToast('Erro ao carregar categorias e fornecedores', 'warning');
            } finally {
                setCarregandoDados(false);
            }
        };

        carregarDados();
    }, [showToast]);

    useEffect(() => {
        if (!location.state?.produtosProcessados) {
            showToast('Nenhum produto para importar', 'error');
            navigate('/menu/produtos_e_estoque');
            return;
        }

        setProdutosProcessados(location.state.produtosProcessados);
        setUsuarioId(location.state.usuario_id);
        
        console.log('[DEBUG] Produtos do Excel:', location.state.produtosProcessados.slice(0, 2));
        
        // Inicializar produtosEditaveis com os dados dos produtos
        const editaveis = {};
        location.state.produtosProcessados.forEach((produto, idx) => {
            editaveis[idx] = JSON.parse(JSON.stringify(produto));
            if (idx < 2) {
                console.log(`[DEBUG] Produto ${idx} - idCategoria: '${produto.idCategoria}', idFornecedor: '${produto.idFornecedor}'`);
            }
        });
        setProdutosEditaveis(editaveis);
    }, [location, navigate, showToast]);

    const handleConfirmarImportacao = async () => {
        // Validar se há categorias e fornecedores
        if (!categorias.length || !fornecedores.length) {
            showToast('Categorias e fornecedores não carregados. Tente novamente.', 'error');
            return;
        }

        // Validar se todos os produtos têm categoria e fornecedor selecionados
        for (let idx = 0; idx < Object.keys(produtosEditaveis).length; idx++) {
            const produto = produtosEditaveis[idx];
            if (!produto?.idCategoria || !produto?.idFornecedor) {
                showToast(`Produto "${produto?.nome || `#${idx}`}" sem categoria ou fornecedor selecionado`, 'error');
                return;
            }

            const variacoes = produto?.variacoes || [];
            const variacaoInvalida = variacoes.findIndex((variacao) => {
                const unidades = parseInt(variacao.unidades_por_pacote, 10);
                return isNaN(unidades) || unidades <= 0;
            });
            if (variacaoInvalida >= 0) {
                showToast(`Unidades por pacote inválido na variação ${variacaoInvalida + 1} do produto "${produto?.nome || `#${idx}`}"`, 'error');
                return;
            }
        }

        const totalProdutos = Object.keys(produtosEditaveis).length;
        setCarregando(true);
        setProgresso({ atual: 0, total: totalProdutos });
        setLogImportacao([]);

        try {
            let sucessos = 0;
            let erros = [];

            // Enviar cada produto um de cada vez
            for (let produtoIdx = 0; produtoIdx < totalProdutos; produtoIdx++) {
                const produto = produtosEditaveis[produtoIdx];
                if (!produto) continue;
                
                // Atualizar progresso
                setProgresso({ atual: produtoIdx + 1, total: totalProdutos });
                setLogImportacao(prev => [...prev, { 
                    nome: produto.nome, 
                    status: 'processando',
                    mensagem: 'Enviando...'
                }]);

                try {
                    const formData = new FormData();
                    
                    // Validar categoria e fornecedor antes de enviar
                    const idCat = Number(produto.idCategoria);
                    const idForn = Number(produto.idFornecedor);
                    
                    if (!produto.idCategoria || isNaN(idCat) || idCat <= 0) {
                        throw new Error(`Categoria inválida para produto "${produto.nome}"`);
                    }
                    
                    if (!produto.idFornecedor || isNaN(idForn) || idForn <= 0) {
                        throw new Error(`Fornecedor inválido para produto "${produto.nome}"`);
                    }
                    
                    // Adicionar campos básicos do produto
                    formData.append('nome', produto.nome);
                    formData.append('descricao', produto.descricao);
                    formData.append('descricao_longa', produto.descricaoLonga || '');
                    formData.append('codigo_barras', produto.codigoBarras || `${Math.random().toString(36).substring(2, 15)}`);
                    formData.append('marca', produto.marca || 'Sem marca');
                    formData.append('status', produto.status || 'ativo');
                    formData.append('id_categoria', idCat);
                    formData.append('id_fornecedor', idForn);
                    
                    // Adicionar variações
                    const variacoes = produto.variacoes || [];
                    
                    variacoes.forEach((variacao, indiceVariacao) => {
                        // Adicionar campos de variação
                        formData.append(`variacoes[${indiceVariacao}][tamanho]`, variacao.tamanho || '');
                        formData.append(`variacoes[${indiceVariacao}][cor]`, variacao.cor || '');
                        formData.append(`variacoes[${indiceVariacao}][material]`, variacao.material || '');
                        formData.append(`variacoes[${indiceVariacao}][tipo]`, variacao.tipo || '');
                        formData.append(`variacoes[${indiceVariacao}][unidades_por_pacote]`, Number(variacao.unidades_por_pacote) || 0);
                        formData.append(`variacoes[${indiceVariacao}][preco_compra]`, Number(variacao.preco_compra) || 0);
                        formData.append(`variacoes[${indiceVariacao}][preco_varejo]`, Number(variacao.preco_varejo) || 0);
                        formData.append(`variacoes[${indiceVariacao}][preco_atacado]`, Number(variacao.preco_atacado) || 0);
                        formData.append(`variacoes[${indiceVariacao}][estoque]`, Number(variacao.estoque) || 0);
                        formData.append(`variacoes[${indiceVariacao}][sku]`, variacao.sku || '');
                        formData.append(`variacoes[${indiceVariacao}][peso]`, Number(variacao.peso) || 0);
                        formData.append(`variacoes[${indiceVariacao}][altura]`, Number(variacao.altura) || 0);
                        formData.append(`variacoes[${indiceVariacao}][largura]`, Number(variacao.largura) || 0);
                        formData.append(`variacoes[${indiceVariacao}][profundidade]`, Number(variacao.profundidade) || 0);
                        
                        // Adicionar imagens por variação - COM ÍNDICE DE IMAGEM
                        const variacao_key = `${produtoIdx}-${indiceVariacao}`;
                        const imagensVariacao = imagensPorVariacao[variacao_key] || [];
                        
                        if (imagensVariacao.length > 0) {
                            // Se tiver imagens adicionadas, enviar todas com índice
                            imagensVariacao.forEach((imagemObj, imgIdx) => {
                                formData.append(`variacoes[${indiceVariacao}][imagens][${imgIdx}]`, imagemObj.file);
                            });
                        }
                        // Se não tiver imagem, NÃO envia nada - backend vai usar padrão
                    });

                    const response = await api.post('/produtos', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        timeout: 60000 // 60 segundos por produto
                    });

                    console.log(`[Produto ${produtoIdx + 1}] Response:`, response.data);

                    if (response.data.success) {
                        sucessos++;
                        setLogImportacao(prev => {
                            const novo = [...prev];
                            novo[produtoIdx] = { 
                                nome: produto.nome, 
                                status: 'sucesso',
                                mensagem: 'Adicionado com sucesso!'
                            };
                            return novo;
                        });
                        
                        // ✅ REMOVER produto com sucesso da lista
                        setProdutosEditaveis(prev => {
                            const atualizado = { ...prev };
                            delete atualizado[produtoIdx];
                            return atualizado;
                        });
                    } else {
                        const erro = response.data.message || response.data.error || 'Erro desconhecido';
                        console.error(`[Produto ${produtoIdx + 1}] Erro:`, erro, response.data);
                        erros.push(`${produto.nome}: ${erro}`);
                        setLogImportacao(prev => {
                            const novo = [...prev];
                            novo[produtoIdx] = { 
                                nome: produto.nome, 
                                status: 'erro',
                                mensagem: erro
                            };
                            return novo;
                        });
                    }
                } catch (error) {
                    const mensagemErro = error.response?.data?.message || error.response?.data?.error || error.message || 'Erro ao enviar';
                    console.error(`[Produto ${produtoIdx + 1}] Exception:`, {
                        mensagem: mensagemErro,
                        status: error.response?.status,
                        data: error.response?.data
                    });
                    erros.push(`${produto.nome}: ${mensagemErro}`);
                    setLogImportacao(prev => {
                        const novo = [...prev];
                        novo[produtoIdx] = { 
                            nome: produto.nome, 
                            status: 'erro',
                            mensagem: mensagemErro
                        };
                        return novo;
                    });
                    console.error(`Erro ao adicionar ${produto.nome}:`, error);
                }

                // Delay maior para evitar rate limiting
                await new Promise(resolve => setTimeout(resolve, 1000));
            }

            // Mostrar resultado final
            console.log('[FINAL] Importação concluída:', { sucessos, totalProdutos, erros });
            
            if (sucessos > 0) {
                const totalComErro = Object.keys(produtosEditaveis).length;
                
                if (totalComErro === 0) {
                    // ✅ Todos importados com sucesso
                    showToast(`✅ Todos os ${sucessos} produto(s) adicionado(s) com sucesso!`, 'success');
                    setTimeout(() => {
                        navigate('/menu/produtos_e_estoque');
                    }, 2000);
                } else {
                    // ⚠️ Alguns falharam
                    const mensagem = `✅ ${sucessos} produtos importados com sucesso! ❌ ${totalComErro} com erro (continuam na lista para tentar novamente)`;
                    showToast(mensagem, 'warning');
                }
            } else if (erros.length > 0) {
                // ❌ Nenhum sucesso
                const mensagemErros = erros.slice(0, 5).join('\n');
                console.error('Erros detalhados:', erros);
                showToast(`❌ Nenhum produto foi adicionado.\n${mensagemErros}`, 'error');
            }
        } catch (error) {
            console.error('Erro ao importar produtos:', error);
            showToast('Erro ao importar produtos', 'error');
        } finally {
            setCarregando(false);
        }
    };

    const handleCancelar = () => {
        navigate('/menu/produtos_e_estoque');
    };

    const handleAdicionarImagem = (e, produtoIndex, variacaoIndex) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        const variacao_key = `${produtoIndex}-${variacaoIndex}`;
        
        Array.from(files).forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                setImagensPorVariacao((prev) => {
                    const imagensAtuais = prev[variacao_key] || [];
                    return {
                        ...prev,
                        [variacao_key]: [...imagensAtuais, { file, preview: event.target.result }]
                    };
                });
            };
            reader.readAsDataURL(file);
        });

        // Limpar o input para permitir selecionar o mesmo arquivo novamente
        e.target.value = '';
    };

    const handleRemoverImagem = (produtoIndex, variacaoIndex, imagemIndex) => {
        const variacao_key = `${produtoIndex}-${variacaoIndex}`;
        setImagensPorVariacao((prev) => {
            const imagensAtuais = prev[variacao_key] || [];
            return {
                ...prev,
                [variacao_key]: imagensAtuais.filter((_, idx) => idx !== imagemIndex)
            };
        });
    };

    const acionarInputFile = (produtoIndex, variacaoIndex) => {
        const key = `${produtoIndex}-${variacaoIndex}`;
        if (fileInputsRef.current[key]) {
            fileInputsRef.current[key].click();
        }
    };

    const atualizarCampoProduto = (produtoIndex, campo, valor) => {
        setProdutosEditaveis((prev) => ({
            ...prev,
            [produtoIndex]: {
                ...prev[produtoIndex],
                [campo]: valor
            }
        }));
    };

    const atualizarVariacao = (produtoIndex, variacaoIndex, campo, valor) => {
        setProdutosEditaveis((prev) => {
            const novoEstado = { ...prev };
            if (!novoEstado[produtoIndex]) return prev;
            
            const novasVariacoes = [...novoEstado[produtoIndex].variacoes];
            novasVariacoes[variacaoIndex] = {
                ...novasVariacoes[variacaoIndex],
                [campo]: valor
            };
            
            return {
                ...prev,
                [produtoIndex]: {
                    ...novoEstado[produtoIndex],
                    variacoes: novasVariacoes
                }
            };
        });
    };

    // Função para formatar valor em Real Brasileiro
    const formatarPreco = (valor) => {
        const numero = parseFloat(valor) || 0;
        return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    // Função para converter preço formatado para número
    const converterPrecoParaNumero = (texto) => {
        if (!texto) return 0;
        const numero = texto.toString().replace(/[^\d,]/g, '').replace(',', '.');
        return parseFloat(numero) || 0;
    };

    // Função para formatar input de preço enquanto digita
    const formatarInputPreco = (valor) => {
        let numero = valor.toString().replace(/\D/g, '');
        numero = (parseFloat(numero) / 100).toFixed(2);
        return numero;
    };

    // Função para adicionar nova variação
    const adicionarVariacao = (produtoIndex) => {
        setProdutosEditaveis((prev) => {
            const novoEstado = { ...prev };
            if (!novoEstado[produtoIndex]) return prev;

            const novaVariacao = {
                tamanho: '',
                cor: '',
                material: '',
                tipo: '',
                unidades_por_pacote: 1,
                preco_compra: 0,
                preco_varejo: 0,
                preco_atacado: 0,
                estoque: 0,
                sku: '',
                peso: 0,
                altura: 0,
                largura: 0,
                profundidade: 0
            };

            return {
                ...prev,
                [produtoIndex]: {
                    ...novoEstado[produtoIndex],
                    variacoes: [...novoEstado[produtoIndex].variacoes, novaVariacao]
                }
            };
        });
    };

    // Função para remover variação
    const removerVariacao = (produtoIndex, variacaoIndex) => {
        setProdutosEditaveis((prev) => {
            const novoEstado = { ...prev };
            if (!novoEstado[produtoIndex] || novoEstado[produtoIndex].variacoes.length <= 1) {
                showToast('O produto deve ter pelo menos uma variação', 'warning');
                return prev;
            }

            const novasVariacoes = novoEstado[produtoIndex].variacoes.filter((_, idx) => idx !== variacaoIndex);

            return {
                ...prev,
                [produtoIndex]: {
                    ...novoEstado[produtoIndex],
                    variacoes: novasVariacoes
                }
            };
        });
    };

    return (
        <section className='container-principal-preview-importacao'>
            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className='conteudo-preview-importacao'>
                    <div className='titulo-preview'>
                        <h1>Preview de Importação</h1>
                        <p>Revise os produtos antes de adicionar ao estoque</p>
                    </div>
                    <BtnVoltar />
                    {carregandoDados && (
                        <div className='aviso-carregando'>
                            <p>Carregando categorias e fornecedores...</p>
                        </div>
                    )}

                    <div className='resumo-importacao'>
                        <div className='card-resumo'>
                            <h3>Total de Produtos</h3>
                            <p className='numero'>{produtosProcessados.length}</p>
                        </div>
                    </div>

                    <div className='produtos-preview'>
                        {Object.keys(produtosEditaveis).map((index) => {
                            const produto = produtosEditaveis[index];
                            const produtoIndex = parseInt(index);
                            
                            return (
                            <div key={produtoIndex} className='card-produto-preview'>
                                <div className='header-produto'>
                                    <h3>Produto #{produtoIndex + 1}</h3>
                                    <span className='badge-variacao'>{produto.variacoes.length} variação(ões)</span>
                                </div>

                                {/* CAMPOS EDITÁVEIS DO PRODUTO */}
                                <div className='info-produto'>
                                    {/* Nome */}
                                    <div className='campo'>
                                        <label>Nome do Produto:</label>
                                        <input
                                            type='text'
                                            value={produto.nome || ''}
                                            onChange={(e) => atualizarCampoProduto(produtoIndex, 'nome', e.target.value)}
                                            placeholder='Nome do produto'
                                            className='input-editavel'
                                        />
                                    </div>

                                    {/* Descrição */}
                                    <div className='campo'>
                                        <label>Descrição:</label>
                                        <textarea
                                            value={produto.descricao || ''}
                                            onChange={(e) => atualizarCampoProduto(produtoIndex, 'descricao', e.target.value)}
                                            placeholder='Descrição breve'
                                            rows='3'
                                            className='textarea-editavel'
                                        />
                                    </div>

                                    {/* Descrição Longa */}
                                    <div className='campo'>
                                        <label>Descrição Longa:</label>
                                        <textarea
                                            value={produto.descricaoLonga || ''}
                                            onChange={(e) => atualizarCampoProduto(produtoIndex, 'descricaoLonga', e.target.value)}
                                            placeholder='Descrição detalhada'
                                            rows='4'
                                            className='textarea-editavel'
                                        />
                                    </div>

                                    <div className='campos-duplos'>
                                        {/* Código de Barras */}
                                        <div className='campo'>
                                            <label>Código de Barras:</label>
                                            <input
                                                type='text'
                                                value={produto.codigoBarras || ''}
                                                onChange={(e) => atualizarCampoProduto(produtoIndex, 'codigoBarras', e.target.value)}
                                                placeholder='Código de barras'
                                                className='input-editavel'
                                            />
                                        </div>

                                        {/* Marca */}
                                        <div className='campo'>
                                            <label>Marca:</label>
                                            <input
                                                type='text'
                                                value={produto.marca || ''}
                                                onChange={(e) => atualizarCampoProduto(produtoIndex, 'marca', e.target.value)}
                                                placeholder='Marca do produto'
                                                className='input-editavel'
                                            />
                                        </div>
                                    </div>

                                    <div className='campos-duplos'>
                                        {/* Categoria */}
                                        <div className='campo'>
                                            <label>Categoria:</label>
                                            <select
                                                value={produto.idCategoria || ''}
                                                onChange={(e) => {
                                                    console.log('[INFO] Categoria selecionada:', e.target.value);
                                                    atualizarCampoProduto(produtoIndex, 'idCategoria', e.target.value);
                                                }}
                                                className='input-editavel'
                                            >
                                                <option value=''>-- Selecione uma categoria --</option>
                                                {categorias.map((cat) => (
                                                    cat.id_categoria ? (
                                                        <option key={cat.id_categoria} value={cat.id_categoria}>
                                                            {cat.nome}
                                                        </option>
                                                    ) : null
                                                ))}
                                            </select>
                                        </div>

                                        {/* Fornecedor */}
                                        <div className='campo'>
                                            <label>Fornecedor:</label>
                                            <select
                                                value={produto.idFornecedor || ''}
                                                onChange={(e) => {
                                                    console.log('[INFO] Fornecedor selecionado:', e.target.value);
                                                    atualizarCampoProduto(produtoIndex, 'idFornecedor', e.target.value);
                                                }}
                                                className='input-editavel'
                                            >
                                                <option value=''>-- Selecione um fornecedor --</option>
                                                {fornecedores.map((forn) => (
                                                    forn.id ? (
                                                        <option key={forn.id} value={forn.id}>
                                                            {forn.nome}
                                                        </option>
                                                    ) : null
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* VARIAÇÕES EDITÁVEIS */}
                                <div className='variacoes-preview'>
                                    <div className='header-variacoes'>
                                        <h4>Variações ({produto.variacoes.length})</h4>
                                        <button 
                                            className='btn-adicionar-variacao'
                                            onClick={() => adicionarVariacao(produtoIndex)}
                                            type='button'
                                            title='Adicionar nova variação'
                                        >
                                            + Nova Variação
                                        </button>
                                    </div>
                                    <div className='container-variacoes-editaveis'>
                                        {produto.variacoes.map((variacao, variacaoIdx) => (
                                            <div key={variacaoIdx} className='card-variacao-editavel'>
                                                <div className='header-card-variacao'>
                                                    <h5>Variação {variacaoIdx + 1}</h5>
                                                    {produto.variacoes.length > 1 && (
                                                        <button
                                                            className='btn-remover-variacao'
                                                            onClick={() => removerVariacao(produtoIndex, variacaoIdx)}
                                                            type='button'
                                                            title='Remover variação'
                                                        >
                                                            × Remover
                                                        </button>
                                                    )}
                                                </div>
                                                <div className='campos-variacao'>
                                                    <div className='grupo-campos-duplos'>
                                                        <div className='campo'>
                                                            <label>Tamanho:</label>
                                                            <input
                                                                type='text'
                                                                value={variacao.tamanho || ''}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'tamanho', e.target.value)}
                                                                placeholder='Tamanho'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Cor:</label>
                                                            <input
                                                                type='text'
                                                                value={variacao.cor || ''}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'cor', e.target.value)}
                                                                placeholder='Cor'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Material:</label>
                                                            <input
                                                                type='text'
                                                                value={variacao.material || ''}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'material', e.target.value)}
                                                                placeholder='Material'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Peso (kg):</label>
                                                            <input
                                                                type='number'
                                                                step='0.01'
                                                                value={variacao.peso || 0}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'peso', parseFloat(e.target.value) || 0)}
                                                                placeholder='0,00'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='grupo-campos-duplos'>
                                                        <div className='campo'>
                                                            <label>Tipo:</label>
                                                            <input
                                                                type='text'
                                                                value={variacao.tipo || ''}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'tipo', e.target.value)}
                                                                placeholder='Tipo'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Unidades por pacote:</label>
                                                            <input
                                                                type='number'
                                                                value={variacao.unidades_por_pacote || ''}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'unidades_por_pacote', parseInt(e.target.value, 10))}
                                                                placeholder='1'
                                                                min='1'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Altura (cm):</label>
                                                            <input
                                                                type='number'
                                                                step='0.01'
                                                                value={variacao.altura || 0}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'altura', parseFloat(e.target.value) || 0)}
                                                                placeholder='0,00'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Largura (cm):</label>
                                                            <input
                                                                type='number'
                                                                step='0.01'
                                                                value={variacao.largura || 0}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'largura', parseFloat(e.target.value) || 0)}
                                                                placeholder='0,00'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='grupo-campos-duplos'>
                                                        <div className='campo'>
                                                            <label>Profundidade (cm):</label>
                                                            <input
                                                                type='number'
                                                                step='0.01'
                                                                value={variacao.profundidade || 0}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'profundidade', parseFloat(e.target.value) || 0)}
                                                                placeholder='0,00'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='grupo-campos-duplos'>
                                                        <div className='campo'>
                                                            <label>Preço Compra:</label>
                                                            <input
                                                                type='text'
                                                                value={formatarPreco(variacao.preco_compra || 0)}
                                                                onChange={(e) => {
                                                                    const valor = formatarInputPreco(e.target.value);
                                                                    atualizarVariacao(produtoIndex, variacaoIdx, 'preco_compra', parseFloat(valor));
                                                                }}
                                                                placeholder='R$ 0,00'
                                                                className='input-editavel input-preco'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Preço Varejo:</label>
                                                            <input
                                                                type='text'
                                                                value={formatarPreco(variacao.preco_varejo || 0)}
                                                                onChange={(e) => {
                                                                    const valor = formatarInputPreco(e.target.value);
                                                                    atualizarVariacao(produtoIndex, variacaoIdx, 'preco_varejo', parseFloat(valor));
                                                                }}
                                                                placeholder='R$ 0,00'
                                                                className='input-editavel input-preco'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Preço Atacado:</label>
                                                            <input
                                                                type='text'
                                                                value={formatarPreco(variacao.preco_atacado || 0)}
                                                                onChange={(e) => {
                                                                    const valor = formatarInputPreco(e.target.value);
                                                                    atualizarVariacao(produtoIndex, variacaoIdx, 'preco_atacado', parseFloat(valor));
                                                                }}
                                                                placeholder='R$ 0,00'
                                                                className='input-editavel input-preco'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='grupo-campos-duplos'>
                                                        <div className='campo'>
                                                            <label>Estoque:</label>
                                                            <input
                                                                type='number'
                                                                value={variacao.estoque || 0}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'estoque', parseInt(e.target.value))}
                                                                placeholder='0'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>SKU:</label>
                                                            <input
                                                                type='text'
                                                                value={variacao.sku || ''}
                                                                onChange={(e) => atualizarVariacao(produtoIndex, variacaoIdx, 'sku', e.target.value)}
                                                                placeholder='SKU'
                                                                className='input-editavel'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* IMAGENS DA VARIAÇÃO */}
                                                <div className='secao-imagens-variacao'>
                                                    <label className='label-variacao'>
                                                        {`Imagens - ${variacao.tamanho && variacao.cor ? `${variacao.tamanho} - ${variacao.cor}` : `Variação ${variacaoIdx + 1}`}`}
                                                    </label>
                                                    
                                                    <div className='grid-miniaturas'>
                                                        {(() => {
                                                            const variacao_key = `${produtoIndex}-${variacaoIdx}`;
                                                            const imagensVariacao = imagensPorVariacao[variacao_key] || [];
                                                            
                                                            return imagensVariacao.length > 0 ? (
                                                                imagensVariacao.map((imagemObj, imgIdx) => (
                                                                    <div key={imgIdx} className='card-imagem-miniatura'>
                                                                        <img src={imagemObj.preview} alt={`Imagem ${imgIdx + 1}`} />
                                                                        <button 
                                                                            className='btn-remover-imagem'
                                                                            onClick={() => handleRemoverImagem(produtoIndex, variacaoIdx, imgIdx)}
                                                                            type='button'
                                                                            title='Remover imagem'
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div className='vazio-imagens'>
                                                                    Nenhuma imagem adicionada
                                                                </div>
                                                            );
                                                        })()}
                                                    </div>
                                                    
                                                    <button 
                                                        className='btn-adicionar-imagem'
                                                        onClick={() => acionarInputFile(produtoIndex, variacaoIdx)}
                                                        type='button'
                                                    >
                                                        + Adicionar Imagem
                                                    </button>

                                                    <input
                                                        ref={(el) => {
                                                            if (el) fileInputsRef.current[`${produtoIndex}-${variacaoIdx}`] = el;
                                                        }}
                                                        type='file'
                                                        multiple
                                                        accept='image/*'
                                                        onChange={(e) => handleAdicionarImagem(e, produtoIndex, variacaoIdx)}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            );
                        })}
                    </div>

                    {/* BARRA DE PROGRESSO E LOG */}
                    {carregando && (
                        <div className='container-progresso'>
                            <div className='info-progresso'>
                                <h3>Importando Produtos...</h3>
                                <p>{progresso.atual} de {progresso.total} produtos processados</p>
                            </div>
                            
                            <div className='barra-progresso'>
                                <div 
                                    className='barra-progresso-fill'
                                    style={{ width: `${(progresso.atual / progresso.total) * 100}%` }}
                                />
                            </div>

                            <div className='log-importacao'>
                                {logImportacao.map((log, idx) => (
                                    <div key={idx} className={`log-item log-${log.status}`}>
                                        <span className='log-nome'>{log.nome}</span>
                                        <span className='log-mensagem'>{log.mensagem}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className='bnts-acao-preview'>
                        <button 
                            className='bnt-cancelar' 
                            onClick={handleCancelar}
                            disabled={carregando}
                        >
                            {Object.keys(produtosEditaveis).length === 0 && !carregando ? 'Voltar' : 'Cancelar'}
                        </button>

                        {/* Mostrar "Tentar Novamente" se houver produtos com erro */}
                        {!carregando && progresso.total > 0 && Object.keys(produtosEditaveis).length > 0 && (
                            <button 
                                className='bnt-novamente' 
                                onClick={() => {
                                    setProgresso({ atual: 0, total: Object.keys(produtosEditaveis).length });
                                    setLogImportacao([]);
                                    handleConfirmarImportacao();
                                }}
                                style={{ backgroundColor: '#FF9800' }}
                            >
                                🔄 Tentar Novamente ({Object.keys(produtosEditaveis).length})
                            </button>
                        )}

                        {/* Mostrar "Confirmar Importação" se não tiver iniciado ou todos estão prontos */}
                        {(progresso.total === 0 || (carregando === false && Object.keys(produtosEditaveis).length === Object.keys(produtosEditaveis).length)) && !carregando && (
                            <button 
                                className='bnt-confirmar' 
                                onClick={handleConfirmarImportacao}
                                disabled={Object.keys(produtosEditaveis).length === 0}
                            >
                                {Object.keys(produtosEditaveis).length === 0 ? 'Tudo OK! ✓' : 'Confirmar Importação'}
                            </button>
                        )}

                        {/* Mostrar "Importando..." durante o processo */}
                        {carregando && (
                            <button 
                                className='bnt-confirmar' 
                                disabled
                            >
                                Importando... {progresso.atual}/{progresso.total}
                            </button>
                        )}
                    </div>
                </section>
            </main>
            <Rodape />
        </section>
    );
}
